import Router from 'vue-router'

// 懒加载方式，当路由被访问的时候才加载对应组件
const Home = resolve => require(['@/view/Home'], resolve)
const User = resolve => require(['@/view/user/User'], resolve)
const Admin = resolve => require(['@/view/user/Admin'], resolve)
const Login = resolve => require(['@/view/user/Login'], resolve)
const changepwd = resolve => require(['@/view/user/changepwd'], resolve)
const Role = resolve => require(['@/view/user/Role'], resolve)
const userAuth = resolve => require(['@/view/user/userAuth'], resolve)
const RoleApply = resolve => require(['@/view/user/RoleApply'], resolve)
const UserAudit = resolve => require(['@/view/user/UserAudit'], resolve)

const itemCategory = resolve => require(['@/view/item/itemCategory'], resolve)
const item = resolve => require(['@/view/item/item'], resolve)
const reportItem = resolve => require(['@/view/item/reportItem'], resolve)
const reportType = resolve => require(['@/view/item/reportType'], resolve)
const reply = resolve => require(['@/view/item/reply'], resolve)
const topItem = resolve => require(['@/view/item/topItem'], resolve)
const homePopupItem = resolve => require(['@/view/item/homePopupItem'], resolve)
const magazine = resolve => require(['@/view/item/magazine'], resolve)
const banner = resolve => require(['@/view/item/banner'], resolve)

const bannerEdu = resolve => require(['@/view/item/bannerEdu'], resolve)
const room = resolve => require(['@/view/item/room'], resolve)

const school = resolve => require(['@/view/school/school'], resolve)
const schoolAudit = resolve => require(['@/view/school/schoolAudit'], resolve)
const schoolBindApply = resolve => require(['@/view/school/schoolBindApply'], resolve)
const msgPush = resolve => require(['@/view/message/msgPush'], resolve)
const schoolChildApply = resolve => require(['@/view/school/schoolChildApply'], resolve)
const schoolLinkman = resolve => require(['@/view/school/schoolLinkman'], resolve)
const schoolLevel = resolve => require(['@/view/school/schoolLevel'], resolve)
const schoolEdit = resolve => require(['@/view/school/schoolEdit'], resolve)

const Phonograph = resolve => require(['@/view/item/phonograph'], resolve)
const PhonographClassification = resolve => require(['@/view/item/phonographClassification'], resolve)
const PhonographClassification2 = resolve => require(['@/view/item/phonographClassification2'], resolve)
const PhonographClassification3 = resolve => require(['@/view/item/phonographClassification3'], resolve)

const widget = resolve => require(['@/view/widget/widget'], resolve)
const widgetNew = resolve => require(['@/view/widgetNew/widgetNew'], resolve)
const order = resolve => require(['@/view/order/order'], resolve)
const vipOrder = resolve => require(['@/view/order/vipOrder'], resolve)
const empty = resolve => require(['@/view/empty'], resolve)
const feedBack = resolve => require(['@/view/user/feedBack'], resolve)
const label = resolve => require(['@/view/item/label'], resolve)
const homeheadline = resolve => require(['@/view/item/homeheadline'], resolve)
const experienceExchange = resolve => require(['@/view/item/experienceExchange'], resolve)
const submit = resolve => require(['@/view/item/submit'], resolve)
const searchRecom = resolve => require(['@/view/item/searchRecom'], resolve)
const navigationArea = resolve => require(['@/view/item/navigationArea'], resolve)
const topic = resolve => require(['@/view/item/topic'], resolve)
const topicInfo = resolve => require(['@/view/item/topicInfo'], resolve)
const itemCount = resolve => require(['@/view/itemCount/itemCount'], resolve)
const albumCount = resolve => require(['@/view/itemCount/albumCount'], resolve)
const activityInfo = resolve => require(['@/view/activityInfo/activityInfo'], resolve)
const auth = resolve => require(['@/view/auth/auth'], resolve)
// 教育圈路由
const Vuser = resolve => require(['@/view/education/Vuser'], resolve)
const WatchList = resolve => require(['@/view/education/WatchList'], resolve)
const News = resolve => require(['@/view/education/News'], resolve)
const TopicList = resolve => require(['@/view/education/TopicList'], resolve)
const FriendList = resolve => require(['@/view/education/FriendList'], resolve)
const Course = resolve => require(['@/view/education/Course'], resolve)

const Ad = resolve => require(['@/view/ad/ad'], resolve)

// 数字藏品
const NFTUserList = resolve => require(['@/view/nft/index'], resolve)

const keyWord = resolve => require(['@/view/user/keyWord'], resolve)

// 系统管理
const task = resolve => require(['@/view/task/task'], resolve)
const NotificationTemplate = resolve => require(['@/view/system/notificationTemplate'], resolve)

let router = new Router({
  routes: [{
    path: '/login',
    component: Login,
    name: 'login',
    menuShow: true
  },
  {
    path: '/',
    component: Home,
    redirect: '/login',
    children: [{
      path: '/user',
      component: User,
      name: 'user',
      menuShow: true
    },
    {
      path: '/admin',
      component: Admin,
      name: 'admin',
      menuShow: true
    },
    {
      path: '/changepwd',
      component: changepwd,
      name: 'changepwd',
      menuShow: true
    },
    {
      path: '/itemCategory',
      component: itemCategory,
      name: 'itemCategory',
      menuShow: true
    },
    {
      path: '/item',
      component: item,
      name: 'item',
      menuShow: true
    },
    {
      path: '/reportItem',
      component: reportItem,
      name: 'reportItem',
      menuShow: true
    },
    {
      path: '/reportType',
      component: reportType,
      name: 'reportType',
      menuShow: true
    }, {
      path: '/topItem',
      component: topItem,
      name: 'topItem',
      menuShow: true
    }, {
      path: '/homePopupItem',
      component: homePopupItem,
      name: 'homePopupItem',
      menuShow: true
    }, {
      path: '/Role',
      component: Role,
      name: 'Role',
      menuShow: true
    }, {
      path: '/RoleApply',
      component: RoleApply,
      name: 'RoleApply',
      menuShow: true
    }, {
        path: '/UserAudit',
        component: UserAudit,
        name: 'UserAudit',
        menuShow: true
      }, {
      path: '/school',
      component: school,
      name: 'school',
      menuShow: true
    }, {
        path: '/schoolAudit',
        component: schoolAudit,
        name: 'schoolAudit',
        menuShow: true
    }, {
      path: '/widget',
      component: widget,
      name: 'widget',
      menuShow: true
    }, {
      path: '/widgetNew',
      component: widgetNew,
      name: 'widgetNew',
      menuShow: true
    }, {
      path: '/order',
      component: order,
      name: 'order',
      menuShow: true
    }, {
      path: '/schoolBindApply',
      component: schoolBindApply,
      name: 'schoolBindApply',
      menuShow: true
    },
    {
      path: '/msgPush',
      component: msgPush,
      name: 'msgPush',
      menuShow: true
    }, {
      path: '/schoolChildApply',
      component: schoolChildApply,
      name: 'schoolChildApply',
      menuShow: true
    }, {
      path: '/schoolLevel',
      component: schoolLevel,
      name: 'schoolLevel',
      menuShow: true
    }, {
      path: '/schoolLinkman',
      component: schoolLinkman,
      name: 'schoolLinkman',
      menuShow: true
    },
    {
      path: '/userAuth',
      component: userAuth,
      name: 'userAuth',
      menuShow: true
    },
    {
      path: '/empty',
      component: empty,
      name: 'empty',
      menuShow: true
    }, {
      path: '/schoolEdit',
      component: schoolEdit,
      name: 'schoolEdit',
      menuShow: true
    }, {
      path: '/magazine',
      component: magazine,
      name: 'magazine',
      menuShow: true
    }, {
      path: '/banner',
      component: banner,
      name: 'banner',
      menuShow: true
    }, {
      path: '/bannerEdu',
      component: bannerEdu,
      name: 'bannerEdu',
      menuShow: true
    },{
      path: '/room',
      component: room,
      name: 'room',
      menuShow: true
    }, {
      path: '/vipOrder',
      component: vipOrder,
      name: 'vipOrder',
      menuShow: true
    }, {
      path: '/feedBack',
      component: feedBack,
      name: 'feedBack',
      menuShow: true
    }, {
      path: '/label',
      component: label,
      name: 'label',
      menuShow: true
    }, {
      path: '/homeheadline',
      component: homeheadline,
      name: 'homeheadline',
      menuShow: true
    }, {
      path: '/experienceExchange',
      component: experienceExchange,
      name: 'experienceExchange',
      menuShow: true
    }, {
      path: '/submit',
      component: submit,
      name: 'submit',
      menuShow: true
    }, {
      path: '/searchRecom',
      component: searchRecom,
      name: 'searchRecom',
      menuShow: true
    }, {
      path: '/topic',
      component: topic,
      name: 'topic',
      menuShow: true
    }, {
      path: '/topicInfo',
      component: topicInfo,
      name: 'topicInfo',
      menuShow: true
    }, {
      path: '/itemCount',
      component: itemCount,
      name: 'itemCount',
      menuShow: true
    }, {
      path: '/albumCount',
      component: albumCount,
      name: 'albumCount',
      menuShow: true
    }, {
      path: '/task',
      component: task,
      name: 'task',
      menuShow: true
    },{
        path: '/notificationTemplate',
        component: NotificationTemplate,
        name: 'notificationTemplate',
        menuShow: true
      }, {
      path: '/activityInfo',
      component: activityInfo,
      name: 'activityInfo',
      menuShow: true
    }, {
      path: '/navigationArea',
      component: navigationArea,
      name: 'navigationArea',
      menuShow: true
    }, {
      path: '/auth',
      component: auth,
      name: 'auth',
      menuShow: true
    }, {
      path: '/Vuser',
      component: Vuser,
      name: 'Vuser',
      menuShow: true
    }, {
      path: '/WatchList',
      component: WatchList,
      name: 'WatchList',
      menuShow: true
    }, {
      path: '/reply',
      component: reply,
      name: 'reply',
      menuShow: true
    }, {
      path: '/News',
      component: News,
      name: 'News',
      menuShow: true
    }, {
      path: '/FriendList',
      component: FriendList,
      name: 'FriendList',
      menuShow: true
    }, {
      path: '/TopicList',
      component: TopicList,
      name: 'TopicList',
      menuShow: true
    }, {
      path: '/Course',
      component: Course,
      name: 'Course',
      menuShow: true
    }, {
      path: '/Ad',
      component: Ad,
      name: 'Ad',
      menuShow: true
    }, {
      path: '/phonograph',
      component: Phonograph,
      name: 'Phonograph',
      menuShow: true
    }, {
      path: '/phonographClassification',
      component: PhonographClassification,
      name: 'PhonographClassification',
      menuShow: true
    }, {
      path: '/phonographClassification2',
      component: PhonographClassification2,
      name: 'PhonographClassification2',
      menuShow: true
    }, {
      path: '/phonographClassification3',
      component: PhonographClassification3,
      name: 'PhonographClassification3',
      menuShow: true
    },
    {
      path: '/nftUserList',
      component: NFTUserList,
      name: 'NFTUserList',
      menuShow: true
    },
      {
        path: '/keyWord',
        component: keyWord,
        name: 'keyWord',
        menuShow: true
      },
    ]
  }
  ]
})

// router.beforeEach((to, from, next) => {
//   // console.log('to:' + to.path)
//   if (to.path.startsWith('/login')) {
//     window.localStorage.removeItem('access-user')
//     next()
//   } else {
//     let user = JSON.parse(window.localStorage.getItem('access-user'))
//     if (!user) {
//       next({path: '/login'})
//     } else {
//       next()
//     }
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js